<template>
  <div :class="$style.icon">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
      <g>
        <rect :class="$style[listFillClass]" x="19.4" y="26.2" width="25.3" height="1" />
        <rect :class="$style[listFillClass]" x="19.4" y="35.2" width="25.3" height="1" />
        <rect :class="$style[listFillClass]" x="19.4" y="44.2" width="25.3" height="1" />
        <path
          :class="$style[listFillClass]"
          d="M51,9.3H40.4c-0.2-4.4-3.9-8-8.4-8s-8.2,3.5-8.4,8H13c-1.4,0-2.6,1.2-2.6,2.6v46.3c0,1.4,1.2,2.6,2.6,2.6H51c1.4,0,2.6-1.2,2.6-2.6V11.9C53.6,10.5,52.4,9.3,51,9.3z M52.6,58.3c0,0.9-0.7,1.6-1.6,1.6H13c-0.9,0-1.6-0.7-1.6-1.6V11.9c0-0.9,0.7-1.6,1.6-1.6h6.3v7.9h25.3v-7.9H51c0.9,0,1.6,0.7,1.6,1.6V58.3z"
        />
      </g>
    </svg>
    <ok-icon v-if="status === 'approved'" :class="$style.status" :fill="statusFill" />
    <clock-icon v-if="status === 'in_correction'" :class="$style.status" :fill="statusFill" />
    <error-icon v-if="status === 'rejected'" :class="$style.status" :fill="statusFill" />
  </div>
</template>

<script type="text/ecmascript-6">
import OkIcon from 'components/icons/ok/'
import ClockIcon from 'components/icons/clock/'
import ErrorIcon from 'components/icons/error/'

export default {
  name: 'ReviewStatusIcons',

  components: {
    OkIcon,
    ClockIcon,
    ErrorIcon
  },

  props: {
    status: {
      type: String,
      default: 'approved'
    },
    listFill: {
      type: String,
      default: 'grey'
    },
    statusFill: {
      type: Object,
      default: function () {
        return null
      }
    }
  },

  computed: {
    listFillClass () {
      return `fill${this.listFill}`
    }
  }
}
</script>

<style lang="scss" module>
@import 'mpl-css/lib/assets/global/variables/colors';
@import 'mpl-css/lib/assets/global/functions/index';

.icon {
  position: relative;
  svg {
    width: 100%;
    height: auto;
  }
}

@each $color, $value in $colors {
  .fill#{$color} {
    fill: $value;
  }
}

:root .status {
  position: absolute;
  width: 45%;
  height: 45%;
  top: 65%;
  left: 65%;
}
</style>
